import * as couponCommentTypes from "../types/couponCommentTypes";
import * as authTypes from "../types/authTypes";
import * as userTypes from "../types/userTypes";

const initialState = {
  couponId: null,
  list: [],
  loading: false,
  error: null,
  submitting: false,
  mutatingId: null,
};

export default function couponCommentReducer(state = initialState, action) {
  switch (action.type) {
    case couponCommentTypes.COUPON_COMMENTS_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        couponId: action.payload?.couponPublicId || null,
      };
    case couponCommentTypes.COUPON_COMMENTS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        couponId: action.payload.couponPublicId,
        list: action.payload.comments || [],
      };
    case couponCommentTypes.COUPON_COMMENTS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case couponCommentTypes.COUPON_COMMENT_CREATE_REQUEST:
      return { ...state, submitting: true, error: null };
    case couponCommentTypes.COUPON_COMMENT_CREATE_SUCCESS: {
      const c = action.payload.comment;
      if (!c) return { ...state, submitting: false };
      return {
        ...state,
        submitting: false,
        error: null,
        list: [c, ...state.list],
      };
    }
    case couponCommentTypes.COUPON_COMMENT_CREATE_FAILURE:
      return { ...state, submitting: false, error: action.payload };

    case couponCommentTypes.COUPON_COMMENT_UPDATE_REQUEST:
      return {
        ...state,
        submitting: true,
        error: null,
        mutatingId: action.payload?.commentId || null,
      };
    case couponCommentTypes.COUPON_COMMENT_UPDATE_SUCCESS: {
      const updated = action.payload.comment;
      return {
        ...state,
        submitting: false,
        error: null,
        mutatingId: null,
        list: state.list.map((row) =>
          row.id === updated?.id ? { ...row, ...updated } : row
        ),
      };
    }
    case couponCommentTypes.COUPON_COMMENT_UPDATE_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
        mutatingId: null,
      };

    case couponCommentTypes.COUPON_COMMENT_DELETE_REQUEST:
      return {
        ...state,
        submitting: true,
        error: null,
        mutatingId: action.payload?.commentId || null,
      };
    case couponCommentTypes.COUPON_COMMENT_DELETE_SUCCESS:
      return {
        ...state,
        submitting: false,
        error: null,
        mutatingId: null,
        list: state.list.filter((row) => row.id !== action.payload.commentId),
      };
    case couponCommentTypes.COUPON_COMMENT_DELETE_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
        mutatingId: null,
      };

    case couponCommentTypes.COUPON_COMMENTS_CLEAR:
    case userTypes.USER_CLEAR:
    case authTypes.LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
}
